import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';

const swiperContent = new Swiper('.swiper-posts', {
  modules: [Pagination],
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  autoHeight: true,
  slidesPerView: 1,
  spaceBetween: 32,
});

class SliderPosts {
  
  constructor() {
    this.navItems = document.querySelectorAll('.tabs-posts__nav a');

    this.navItems.forEach((item, index) => {
      item.addEventListener('click', this.onClickNav.bind(this) );
    });
  }

  onClickNav(event) {
    event.preventDefault();
    const selectedItem = event.currentTarget;
    const slug = selectedItem.dataset.slug; 
    this.navItems.forEach(item => item.classList.remove('active'));
    selectedItem.classList.add('active');
    this.changeSlide(slug);
  }

  changeSlide(slug) {
    const allTabs = document.querySelectorAll('.tabs-posts__content');
    const selectedTab = document.querySelector(`.tabs-posts__content[data-id="${slug}"]`);
    allTabs.forEach(tab => tab.classList.add('none'));
    selectedTab.classList.remove('none');
  }

}

new SliderPosts();